"use strict";

var DropdownOption = React.createClass({
  propTypes: {
    option: React.PropTypes.object,
    handleCustomId: React.PropTypes.func,
    handleCustomDisplay: React.PropTypes.func,
  },
  render: function() {
    var id = this.getId();
    var display = this.getDisplay();
    return <option key={id} value={id}>
              {display}
            </option>;
  },
  getId: function () {
    if (typeof this.props.handleCustomId == "function") {
      return this.props.handleCustomId(this.props.option);
    }
    else if (this.props.option) {
      return this.props.option.id;
    }
  },
  getDisplay: function () {
    if (typeof this.props.handleCustomDisplay == "function") {
      return this.props.handleCustomDisplay(this.props.option);
    }
    else if (this.props.option) {
      return this.props.option.name;
    }
  }
});

module.exports = DropdownOption;



// WEBPACK FOOTER //
// ./app/shared/components/Dropdown/dropdown-option.jsx